import request from '@/utils/request'

export function updateStarChangeCfg(data) {
  return request({
    url: 'api/v1/star-exchange/updateStarChangeCfg',
    method: 'post',
    data: data
  })
}

export function getStarChangeList() {
  return request({
    url: 'api/v1/star-exchange/getStarChangeCfg',
    method: 'get'
  })
}

export function delStarChangeList(data) {
  return request({
    url: 'api/v1/star-exchange/delStarChangeCfg',
    method: 'delete',
    data: data
  })
}
